/** Utah's words for whatidid.ts (the state-rule source shown under a fix option). */
export const WHATIDID_UT = {
  /** Extinguisher servicing: Utah OSHA's rule adopting 29 CFR 1910.157(e). */
  extinguisherRule: "Utah Admin. Code R614-1-4 (29 CFR 1910.157(e))",
  /** Hood fire-suppression system servicing: the Utah Fire Prevention Board checklist. */
  hoodRule: "Utah Fire Prevention Board checklist (R710-14-5)",
  /** Backflow assembly tested yearly by a certified tester: the state drinking-water rule. */
  backflowRule: "Utah Admin. Code R309-105-12(5)",
  /** Home kitchen (MEHK) TCS item log: the state home-kitchen law's temperature rule. */
  mehkTcsRule: "Utah Code 26B-7-416(8)(a)",
} as const;
